<template>
  <div>
    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" size="small" @click="$router.push('/admin/edit')">新增文章</el-button>
      <el-tag type="info" size="small">共 {{ articles.length }} 篇</el-tag>
    </div>

    <el-table v-if="!isMobile" :data="articles" border stripe v-loading="loading" style="width:100%;">
      <el-table-column prop="id" label="ID" width="60" align="center"></el-table-column>
      <el-table-column prop="title" label="标题" min-width="250">
        <template slot-scope="{ row }">
          <span class="title-cell">{{ row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="category" label="分类" width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small">{{ row.category }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="author" label="作者" width="80" align="center"></el-table-column>
      <el-table-column prop="viewCount" label="阅读" width="80" align="center"></el-table-column>
      <el-table-column prop="published" label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.published ? 'success' : 'info'" size="small">
            {{ row.published ? '已发布' : '草稿' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="110" align="center">
        <template slot-scope="{ row }">{{ formatDate(row.createdAt) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="160" align="center">
        <template slot-scope="{ row }">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="$router.push(`/admin/edit/${row.id}`)">编辑</el-button>
          <el-popconfirm title="确定删除该文章吗？" @confirm="handleDelete(row.id)">
            <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="isMobile" v-loading="loading">
      <div v-for="row in articles" :key="row.id" class="mobile-article-item">
        <div class="mobile-item-top">
          <el-tag size="mini" type="success">{{ row.category }}</el-tag>
          <el-tag size="mini" :type="row.published ? 'success' : 'info'">{{ row.published ? '已发布' : '草稿' }}</el-tag>
        </div>
        <div class="mobile-item-title">{{ row.title }}</div>
        <div class="mobile-item-bottom">
          <span><i class="el-icon-user"></i> {{ row.author }}</span>
          <span><i class="el-icon-view"></i> {{ row.viewCount }}</span>
          <span>{{ formatDate(row.createdAt) }}</span>
          <div class="mobile-item-actions">
            <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="$router.push(`/admin/edit/${row.id}`)"></el-button>
            <el-popconfirm title="确定删除？" @confirm="handleDelete(row.id)">
              <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete" circle></el-button>
            </el-popconfirm>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'AdminArticles',
  data() {
    return { articles: [], loading: false, isMobile: false }
  },
  created() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    this.loadArticles()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() { this.isMobile = window.innerWidth <= 768 },
    async loadArticles() {
      this.loading = true
      try {
        const { data } = await api.getAllArticles()
        this.articles = data
      } finally {
        this.loading = false
      }
    },
    async handleDelete(id) {
      await api.deleteArticle(id)
      this.$message.success('删除成功')
      this.loadArticles()
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      return `${d.getMonth() + 1}-${d.getDate()}`
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.title-cell { font-weight: 500; }

.mobile-article-item {
  background: white;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.mobile-item-top {
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
}
.mobile-item-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  line-height: 1.5;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.mobile-item-bottom {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: #909399;
  flex-wrap: wrap;
}
.mobile-item-actions {
  margin-left: auto;
  display: flex;
  gap: 5px;
}
</style>
